export enum FinalDispositionStatus {
  Complete = 1,
  Pending = 2,
}
